import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'Components';
import './Bar.css';

const Bar = props => (
  <Button className={classNames('bar', props.className)} onClick={props.onClick}>
    {props.children}
  </Button>
);

Bar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default Bar;



// WEBPACK FOOTER //
// ./src/components/Bar/Bar.jsx